import { defineComponent as _defineComponent } from 'vue'
import LinkButton from 'JS/components/LinkButton.vue';
import UiButton from 'JS/components/UiButton.vue';
import { computed, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RewardsSuccess',
  props: {
    isConnection: { type: Boolean },
    customerHasRewards: { type: Boolean },
    customerEmail: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	isConnection: boolean,
	customerHasRewards: boolean,
	customerEmail: string,
}





const headerFocuser = ref<HTMLElement | null>(null);

const headerText = computed(()=> {
	if (props.customerHasRewards) {
		return "You are already a rewards member.";
	} else if (props.isConnection) {
		return "Connection Successful!";
	} else {
		return "Welcome to Blain's Rewards!";
	}
});

const subtitleText = computed(()=> {
	if (props.customerHasRewards) {
		return "This can happen if you joined in another browser or were assisted by customer service.";
	} else if (props.isConnection) {
		return "Your Blain Account and your Rewards Account are now connected!";
	} else {
		return "Earn 1 point for every $1 spent—that's 1% back! Plus, enjoy special offers and savings.";
	}
});

onMounted(()=> {
	headerFocuser.value?.focus();
});


return { __sfc: true,props, emit, headerFocuser, headerText, subtitleText, LinkButton, UiButton }
}

})